import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GroupConfigData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GroupConfigDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GroupConfigDataStore",
			variables: false,
		})
	}
}

export async function load_GroupConfigData(params) {
  await initClient()

	const store = new GroupConfigDataStore()

	await store.fetch(params)

	return {
		GroupConfigData: store,
	}
}
